import styled, { css } from "../../../styled/index";
export const Table = styled("table") `
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    padding: 7px 5px;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  }
`;
// HEAD
export const TableHead = styled("thead") ``;
export const TableHeadRow = styled("tr") `
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;
export const TableHeadCell = styled("th") `
  font-weight: 600;
  text-align: left;
  &:last-child {
    text-align: right;
  }
`;
// BODY
export const TableBody = styled("tbody") ``;
export const TableRow = styled("tr") `
  ${({ disableBorder }) => disableBorder
    ? css `
          border-bottom: none;
        `
    : css `
          border-bottom: 1px dashed ${({ theme }) => theme.colors.border};
        `}
  ${({ disableLastBorder }) => disableLastBorder
    ? css `
          &:last-child {
            border-bottom: none;
          }
        `
    : css `
          &:last-child {
            border-bottom: 1px solid ${({ theme }) => theme.colors.border};
          }
        `}
`;
export const TableCell = styled("td") `
  text-align: left;
  &:last-child {
    text-align: right;
  }
`;
//# sourceMappingURL=index.js.map